import { EventHandler } from '../../../CommonComponents'
import './Navigation.scss'

const NavigationContainer = (props:any) => {

  return <>
    <div className='navigation-wrapper' id='navigation-wrapper' ref={props?.wrapperRef}>
      <nav className='header-navigation'>
        <ul className={`navmenu-list navmenu-list-activeasset`}>
          {
            props?.menuListAssetInventory.map((item:any, _index:any) => {
              return (            
                <li key={item.id}
                  title={item.Title}
                  onClick={() => { props?.handleClick(item) }}
                  className={item.activeToggle === true ? 'active' : ''}>
                  <a href='/' onClick={(e: any) => e.preventDefault()}><span className={`menu-icon ${item.icon}`}></span><p>{item.text}</p></a></li>)
            })
          }
        </ul>
      </nav>
    </div>
  </>
}

export default NavigationContainer
